import React, {useEffect, useState} from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
//pages
import About from './components/main-menu/About';
import Login from './components/main-menu/Login';
import Register from './components/main-menu/Register';
import ChangePasswordRequest from './components/main-menu/ChangePasswordRequest';
import NewPassword from './components/main-menu/ChangePassword';
import PayByDecoder from './components/main-menu/PayByDecoder';
import AddDecoder from './components/main-menu/AddDecoder';

import Balance from './components/user-menu/Balance';
import Profile from './components/user-menu/Profile';
import PasswrdChange from './components/user-menu/PasswordChange';
import Error from './Error';
import { getUser, addDecoder } from '../shared/service';

//css
import './css/main-menu/App.css';
import './css/main-menu/Service.css';
import './css/main-menu/Login.css';
import './css/main-menu/Captcha.css';
import './css/user-menu/PacketBlock.css'
import './css/user-menu/Adaptive.css';
import './css/user-menu/UserBody.css';
import './css/user-menu/Decoder.css';
import './css/user-menu/CountryList.css';   
import './css/user-menu/Modal.css';

const Routers = () => {
    const [systemIn, setSystemIn] = useState(false);
    const location = useLocation();
    const [dcr_id, setDecId] = useState('');
    const [decoders, setDecoders] = useState('error');

    const fetchUser = async () => {
      try {
        const data = await getUser();
        setDecoders(data ? data?.decoders : 'error');
        setSystemIn(true);
      } catch (error) {
        setSystemIn(false);
      }
    };
    useEffect(() => {
      fetchUser();
    }, [location]);
    const putdec = async (decoder) => {
      try{
        await addDecoder(decoder);
      }
      catch(error){
        console.error(error);
      }
    }

    return(
        <Routes> 
            <Route path="/" element={<About signStatus={systemIn} decoders={decoders}/>} />
            <Route path="/reset" element={<NewPassword />} />  
            <Route path="login" element={<Login dcr_id={dcr_id} putdec={putdec}/>} />
            <Route path="register" element={<Register/>} />
            <Route path="change-password-request" element={<ChangePasswordRequest />} />
            <Route path="add-dcr" element={<AddDecoder onPendingDecoder={setDecId} />} />
            <Route path="pay" element={<PayByDecoder />} />
            <Route path="profile" element={<Profile />}/>
            <Route path="password-change" element={<PasswrdChange />}/> 
            <Route path="balance" element={<Balance />} /> 
            <Route path='*' element={<Error/>}/>
        </Routes>
    )
}

export default Routers;